import {Alert, Typography} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import {FullScreenLoading} from '../components/common/Loading';

export const showSpinner = (showModal) => {
    showModal(({show}) => <FullScreenLoading show={show}></FullScreenLoading>);
};

export const showToastAlert = (
    headerText,
    bodyText,
    variant,
    showModal,
    closeModal
) => {
    showModal(({show}) => (
        <Snackbar
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            open={show}
            autoHideDuration={3000}
            onClose={closeModal}
            message="I love snacks"
            key={'top' + 'right'}>
            <Alert onClose={closeModal} severity={variant} sx={{width: '100%'}}>
                <Typography>{headerText}</Typography>
                {bodyText && <Typography>{bodyText}</Typography>}
            </Alert>
        </Snackbar>
    ));
};
